//TODO: Add this file into elit-tools package and use it in the project
import { isAxiosError } from "axios";
import { toast } from "sonner";

type ErrorHandlerOptions = {
    errorMessage: string;
    permissionDeniedDescription?: string;
    unauthorizedMessage?: string;
    permissionDeniedMessage?: string;
};

export const handleErrorToast = (error: unknown, options: ErrorHandlerOptions) => {
    const {
        errorMessage,
        permissionDeniedDescription,
        unauthorizedMessage = "unauthorized_access",
        permissionDeniedMessage = "permission_denied",
    } = options;

    if (!isAxiosError(error)) {
        toast.error(errorMessage);
        return;
    }

    const status = error.response?.status;

    if (status === 403) {
        toast.error(
            permissionDeniedMessage,
            permissionDeniedDescription ? { description: permissionDeniedDescription } : undefined
        );
        return;
    }

    if (status === 401) {
        toast.error(unauthorizedMessage);
        return;
    }

    toast.error(errorMessage, {
        description: error.response?.data?.message || error.message,
    });
};
